const messages = {
  events_overlap: 'Trener ma już zajęcia w tych godzinach.',
  events_overlaps_with_the_time_window: 'Zajęcia wykraczają poza czas pracy trenera.',
  required_fields_are_not_filled: 'Wszystkie wymagane pola muszą zostałć wypełnione.',
  something_wrong: 'Coś poszło nie tak, spróbuj za chwilę.',
  wrong_event_time: 'Czas rozpoczęcia zajęć nie może być większy ani równy czasowi zakończenia zajęć.',
  wrong_loop_date: 'Pole data musi zawierać wcześniejszą datę niż pole ostatnie zajęcia.',
  no_time_window_for_events: 'Dodane zajęcia nie mieszczą się w oknie czasowym.',
  no_amount_or_client: 'Należy wybrać klienta i dodać wpłacaną kwotę większą od 0.',
  payment_success: 'Zapisano wpłatę.',
  history_is_unavailable: 'Dla tych zajęć historia płatności jest niedostępna.',
  to_short_event: 'Zajęcia nie mogą być krótsze niż 30 minut.',
};

export default messages;
